const NorwaySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112081)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.688965 25.2168C1.84615 29.5105 4.39654 33.2319 7.82607 35.867V25.2168H0.688965Z"
        fill="#D80027"
      />
      <path
        d="M18.2607 39.9233C18.834 39.9727 19.4138 39.9994 19.9999 39.9994C29.2404 39.9994 37.0159 33.7321 39.3109 25.2168H18.2607V39.9233Z"
        fill="#D80027"
      />
      <path
        d="M39.3109 14.7826C37.0159 6.26727 29.2404 0 19.9999 0C19.4138 0 18.834 0.0267187 18.2607 0.0760937V14.7826H39.3109Z"
        fill="#D80027"
      />
      <path
        d="M7.82607 4.13184C4.39654 6.76699 1.84615 10.4883 0.688965 14.782H7.82607V4.13184Z"
        fill="#D80027"
      />
      <path
        d="M39.8307 17.3915H15.6523H15.6522V0.475586C13.8039 0.88543 12.0516 1.54973 10.4348 2.43199V17.3914V17.3914H0.169297C0.0579688 18.2454 0 19.1161 0 20.0002C0 20.8843 0.0579688 21.755 0.169297 22.6089H10.4347H10.4348V37.5683C12.0516 38.4505 13.8039 39.115 15.6522 39.5247V22.6091V22.6089H39.8307C39.9419 21.755 40 20.8843 40 20.0002C40 19.1161 39.9419 18.2454 39.8307 17.3915Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112081">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NorwaySvg;
